import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { SupportChatWidget } from "@/components/support-chat/SupportChatWidget";
import { Hero, Problem, HowItWorks } from "./home/Hero";
import { DashboardPreview, Features, ValueProp } from "./home/ProductSections";
import { Pricing, FAQ, FinalCTA } from "./home/ClosingSections";

export function Home() {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <Problem />
        <HowItWorks />
        <DashboardPreview />
        <Features />
        <ValueProp />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      {/* Step 16: public support chatbot -- landing page only, never the dashboard/admin. */}
      <SupportChatWidget />
    </div>
  );
}
